(function ($, Global) {
    function BannerNewsletterComponent() {
        // Déclaration class objet
    }

	BannerNewsletterComponent.prototype.initEvents = function () {
		this.publishers();
	}

    BannerNewsletterComponent.prototype.publishers = function () {     

        $(window).on('scroll', function () {
            if (!$('#banner-newsletter').exists()) return;
            if ($('#sticky-banner').is(":visible")) {
                $('#chat-widget-container').css('bottom', '70px');
                $('.btn-scroll-up').css('right', '75px' );
            }

            var div1 = $('#banner-newsletter');
            var scrollTop = document.documentElement.scrollTop;
            var div1_top = div1.offset().top;
            var div1_height = div1.height();
            var div1_bottom = div1_top + div1_height;
            var switchClass = (scrollTop + $(window).height()) >= div1_top + div1_height / 2 && scrollTop <= div1_bottom ? 'removeClass' : 'addClass';
            $('#sticky-banner')[switchClass]('d-flex');
		});
	}

    Global.BannerNewsletterComponent = BannerNewsletterComponent;
}(jQuery, window));